var rich_content_viewer_default = {
  "fontElementMap": "XBPVx",
  "wrapper": "aem70",
  "pluginContainerMobile": "jby1u",
  "viewer": "daUSD",
  "android": "_3Gmoq",
  "rootedTraversedContent": "lo-do",
  "atomic": "_6xFmQ",
  "toolbar": "p3rc3",
  "block": "_33Ivu"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
